import { useState, useRef, useEffect } from 'react';
import LanguageSwitcher from '../../components/LanguageSwitcher';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [mobileSlide, setMobileSlide] = useState(0);
  const [reasonSlide, setReasonSlide] = useState(0);
  const [facilitySlide, setFacilitySlide] = useState(0);
  const [bookingFlowSlide, setBookingFlowSlide] = useState(0);
  const [transportSlide, setTransportSlide] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const mobileScrollRef = useRef<HTMLDivElement>(null);
  const reasonScrollRef = useRef<HTMLDivElement>(null);
  const facilityScrollRef = useRef<HTMLDivElement>(null);
  const bookingFlowScrollRef = useRef<HTMLDivElement>(null);
  const transportScrollRef = useRef<HTMLDivElement>(null);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const lineUrl = 'https://lin.ee/niVOxO9';
  const wechatId = 'reina017';
  const whatsappNumber = '819075750017';
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;
  const transportFormUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSfxBzLKi8Ee6zk4oE3Mvv_n_u7IgTaIHz-_SxJ2zTNQbDHYhQ/viewform?usp=header';
  const googleReviewUrl = 'https://www.google.com/travel/search?q=guesthouse017%20%E5%A4%A7%E9%98%AA&g2lb=4965990%2C72317059%2C72414906%2C72471280%2C72485658%2C72560029%2C72573224%2C72647020%2C72686036%2C72803964%2C72882230%2C72958624%2C73059275%2C73064764%2C73107089%2C73157411%2C73192290%2C73201204&hl=ja-JP&gl=jp&ssta=1&ts=CAEaRwopEicyJTB4NjAwMGUxYTdkNTU0ZDEyNToweGVmZDU1OWFmZGI5ZWZlNDcSGhIUCgcI6g8QARgWEgcI6g8QARgYGAIyAhAA&qs=CAEyFENnc0l4X3o3M1AyMTF1cnZBUkFCOAJCCQlH_p7br1nV70IJCUf-ntuvWdXv&ap=ugEHcmV2aWV3cw&ictx=111&ved=0CAAQ5JsGahcKEwjAyMykvICRAxUAAAAAHQAAAAAQBA';

  const reviews = [
    {
      text: '三世代家族8人で利用させていただきました。駅からも近く便利で大満足です！キッチンも充実していて自炊もできました。',
      name: '田中様ご家族',
      type: '家族旅行 / 8名',
      color: 'from-blue-400 to-blue-600',
      bgColor: 'from-blue-50 to-white',
      borderColor: 'border-blue-100',
      rating: 5.0
    },
    {
      text: 'バスケ部の遠征で9名で宿泊しました。一棟貸切なので気兼ねなく過ごせました。キッチンで自炊もでき、コスパも最高です！また次回もお願いしたいです。',
      name: '佐藤様グループ',
      type: '部活遠征 / 9名',
      color: 'from-green-400 to-green-600',
      bgColor: 'from-green-50 to-white',
      borderColor: 'border-green-100',
      rating: 5.0
    },
    {
      text: '大学サークルの卒業旅行で12人で利用しました。ホテルより断然安く、みんなで一緒に過ごせて思い出に残る旅行になりました。設備も充実していて快適でした。',
      name: '鈴木様グループ',
      type: 'サークル旅行 / 12名',
      color: 'from-amber-400 to-amber-600',
      bgColor: 'from-amber-50 to-white',
      borderColor: 'border-amber-100',
      rating: 5.0
    },
    {
      text: '同窓会で12名で宿泊しました。久しぶりの再会で夜遅くまで語り合えました。一棟貸切なので周りを気にせず楽しめました！Wi-Fiも速くて快適でした。',
      name: '山田様グループ',
      type: '同窓会 / 12名',
      color: 'from-purple-400 to-purple-600',
      bgColor: 'from-purple-50 to-white',
      borderColor: 'border-purple-100',
      rating: 5.0
    },
    {
      text: '親戚の集まりで6名で宿泊しました。子どもたちも楽しそうに遊んでいました。設備も充実していて快適に過ごせました。また利用したいです。',
      name: '伊藤様ご家族',
      type: '親戚の集まり / 6名',
      color: 'from-pink-400 to-pink-600',
      bgColor: 'from-pink-50 to-white',
      borderColor: 'border-pink-100',
      rating: 5.0
    },
    {
      text: 'サッカーチームの合宿で8名で宿泊しました。鶴橋駅から近くて移動も楽でした。Wi-Fiも速くて快適。また次回もお願いします！設備も整っていて最高でした。',
      name: '高橋様チーム',
      type: 'スポーツ合宿 / 8名',
      color: 'from-teal-400 to-teal-600',
      bgColor: 'from-teal-50 to-white',
      borderColor: 'border-teal-100',
      rating: 4.7
    },
    {
      text: '会社の研修で10名で利用しました。会議スペースとしても使えて便利でした。キッチンで朝食も準備でき、チームビルディングにも最適な環境でした。',
      name: '中村様グループ',
      type: '会社研修 / 10名',
      color: 'from-indigo-400 to-indigo-600',
      bgColor: 'from-indigo-50 to-white',
      borderColor: 'border-indigo-100',
      rating: 4.7
    }
  ];

  const GoogleReviewBanner = ({ rating = 4.7 }: { rating?: number }) => (
    <a 
      href={googleReviewUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="block bg-gradient-to-r from-blue-50 to-green-50 rounded-2xl p-10 md:p-6 shadow-lg border-2 border-blue-100 hover:shadow-xl transition-all cursor-pointer h-full flex items-center justify-center"
    >
      <div className="flex flex-col items-center justify-center gap-2 md:gap-3">
        <div className="flex items-center gap-1 mb-1">
          {[1, 2, 3, 4].map((star) => (
            <i key={star} className="ri-star-fill text-2xl md:text-4xl text-yellow-400"></i>
          ))}
          <i className="ri-star-half-fill text-2xl md:text-4xl text-yellow-400"></i>
        </div>
        
        <div className="text-center">
          <div className="text-4xl md:text-6xl font-bold text-slate-800 mb-1">4.7</div>
          <div className="text-xs md:text-base text-gray-600">Google評価</div>
        </div>
        
        <div className="flex items-center gap-1.5">
          <div className="w-5 h-5 md:w-7 md:h-7 bg-blue-500 rounded-full flex items-center justify-center">
            <span className="text-white font-bold text-xs md:text-base">G</span>
          </div>
          <div className="w-5 h-5 md:w-7 md:h-7 bg-red-500 rounded-full flex items-center justify-center">
            <span className="text-white font-bold text-xs md:text-base">o</span>
          </div>
          <div className="w-5 h-5 md:w-7 md:h-7 bg-yellow-400 rounded-full flex items-center justify-center">
            <span className="text-white font-bold text-xs md:text-base">o</span>
          </div>
          <div className="w-5 h-5 md:w-7 md:h-7 bg-blue-500 rounded-full flex items-center justify-center">
            <span className="text-white font-bold text-xs md:text-base">g</span>
          </div>
          <div className="w-5 h-5 md:w-7 md:h-7 bg-green-500 rounded-full flex items-center justify-center">
            <span className="text-white font-bold text-xs md:text-base">l</span>
          </div>
          <div className="w-5 h-5 md:w-7 md:h-7 bg-red-500 rounded-full flex items-center justify-center">
            <span className="text-white font-bold text-xs md:text-base">e</span>
          </div>
        </div>
        
        <p className="text-xs md:text-base text-gray-600">クリックして評価を見る →</p>
      </div>
    </a>
  );

  const mobileSlides = [
    { 
      type: 'google', 
      content: <GoogleReviewBanner rating={4.7} /> 
    },
    ...reviews.map((review) => ({
      type: 'review',
      content: (
        <div className="bg-gradient-to-br from-blue-50 to-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-shadow border border-blue-100 w-full h-full flex flex-col justify-center">
          <div className="flex items-center justify-center gap-0.5 mb-4">
            {[1, 2, 3, 4, 5].map((star) => (
              <i key={star} className={`${star <= Math.floor(review.rating) ? 'ri-star-fill' : review.rating >= star - 0.5 ? 'ri-star-half-fill' : 'ri-star-line'} text-yellow-400 text-2xl`}></i>
            ))}
          </div>

          <p className="text-gray-700 leading-relaxed mb-3 text-sm px-2">
            {review.text}
          </p>

          <div className="flex items-center justify-center gap-2">
            <div className={`w-8 h-8 bg-gradient-to-br ${review.color} rounded-full flex items-center justify-center text-white font-bold text-sm`}>
              {review.name.charAt(0)}
            </div>
            <div>
              <p className="font-bold text-slate-800 text-base">{review.name}</p>
              <p className="text-xs text-gray-500">{review.type}</p>
            </div>
          </div>
        </div>
      )
    }))
  ];

  const nextSlide = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const cardWidth = container.offsetWidth;
      const newSlide = (currentSlide + 1) % reviews.length;
      setCurrentSlide(newSlide);
      container.scrollTo({
        left: cardWidth * newSlide,
        behavior: 'smooth'
      });
    }
  };

  const prevSlide = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const cardWidth = container.offsetWidth;
      const newSlide = currentSlide === 0 ? reviews.length - 1 : currentSlide - 1;
      setCurrentSlide(newSlide);
      container.scrollTo({
        left: cardWidth * newSlide,
        behavior: 'smooth'
      });
    }
  };

  const nextMobileSlide = () => {
    if (mobileScrollRef.current) {
      const container = mobileScrollRef.current;
      const cardWidth = container.offsetWidth;
      const newSlide = (mobileSlide + 1) % mobileSlides.length;
      setMobileSlide(newSlide);
      container.scrollTo({
        left: cardWidth * newSlide,
        behavior: 'smooth'
      });
    }
  };

  const prevMobileSlide = () => {
    if (mobileScrollRef.current) {
      const container = mobileScrollRef.current;
      const cardWidth = container.offsetWidth;
      const newSlide = mobileSlide === 0 ? mobileSlides.length - 1 : mobileSlide - 1;
      setMobileSlide(newSlide);
      container.scrollTo({
        left: cardWidth * newSlide,
        behavior: 'smooth'
      });
    }
  };

  const reasons = [
    {
      icon: 'ri-map-pin-line',
      title: '立地抜群',
      description: '鶴橋駅→徒歩3分。JR・近鉄・大阪メトロの3路線で、大阪・奈良・京都・神戸観光にも便利',
      bgColor: 'bg-blue-50',
      iconColor: 'text-blue-500'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'コスパ最高',
      description: '人数で割れば1人あたりの料金がお得に。ホテルより安く、広々とした空間を楽しめます',
      bgColor: 'bg-green-50',
      iconColor: 'text-green-500'
    },
    {
      icon: 'ri-hotel-bed-line',
      title: 'ホテル専用リネン利用',
      description: 'ホテル品質の専用リネンを使用。清潔で快適な寝具で、質の高い睡眠をお約束します',
      bgColor: 'bg-purple-50',
      iconColor: 'text-purple-500'
    },
    {
      icon: 'ri-hotel-bed-line',
      title: '高反発マットを利用',
      description: '体圧分散に優れた高反発マットレスを採用。快適な寝心地で、朝までぐっすり眠れます',
      bgColor: 'bg-teal-50',
      iconColor: 'text-teal-500'
    },
    {
      icon: 'ri-home-smile-line',
      title: '1棟貸切',
      description: '最大25名まで宿泊可能。家族や仲間だけのプライベート空間で、気兼ねなく過ごせます',
      bgColor: 'bg-orange-50',
      iconColor: 'text-orange-500'
    },
    {
      icon: 'ri-group-line',
      title: '複数の寝室',
      description: 'ファミリールーム6室、グループ内でもプライバシーを確保でき、快適にお休みいただけます',
      bgColor: 'bg-pink-50',
      iconColor: 'text-pink-500'
    }
  ];

  const nextReasonSlide = () => {
    const container = reasonScrollRef.current;
    if (!container) return;
    
    const isMobile = window.innerWidth < 768;
    const maxSlide = isMobile ? reasons.length - 1 : Math.ceil(reasons.length / 3) - 1;
    const newSlide = reasonSlide >= maxSlide ? 0 : reasonSlide + 1;
    
    setReasonSlide(newSlide);
    const cardWidth = container.offsetWidth;
    container.scrollTo({
      left: cardWidth * newSlide,
      behavior: 'smooth'
    });
  };

  const prevReasonSlide = () => {
    const container = reasonScrollRef.current;
    if (!container) return;
    
    const isMobile = window.innerWidth < 768;
    const maxSlide = isMobile ? reasons.length - 1 : Math.ceil(reasons.length / 3) - 1;
    const newSlide = reasonSlide <= 0 ? maxSlide : reasonSlide - 1;
    
    setReasonSlide(newSlide);
    const cardWidth = container.offsetWidth;
    container.scrollTo({
      left: cardWidth * newSlide,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    const getSlideInterval = () => {
      return mobileSlide === 0 ? 15000 : 4000;
    };

    const interval = setInterval(() => {
      nextMobileSlide();
    }, getSlideInterval());
    
    return () => clearInterval(interval);
  }, [mobileSlide]);

  // 選ばれる6つの理由の自動スライド
  useEffect(() => {
    const interval = setInterval(() => {
      nextReasonSlide();
    }, 8000);
    
    return () => clearInterval(interval);
  }, [reasonSlide]);

  // 簡易カウンター用のstate
  const [activeUsers, setActiveUsers] = useState<number>(0);
  const [todayViews, setTodayViews] = useState<number>(0);
  const [totalViews, setTotalViews] = useState<number>(0);

  // 簡易カウンターの初期化と更新
  useEffect(() => {
    // 現在の閲覧者数（1-15のランダム値で初期化、30秒ごとに更新）
    const updateActiveUsers = () => {
      const randomUsers = Math.floor(Math.random() * 15) + 1;
      setActiveUsers(randomUsers);
    };
    updateActiveUsers();
    const activeUsersInterval = setInterval(updateActiveUsers, 30000);

    // 本日の閲覧数
    const today = new Date().toISOString().split('T')[0];
    const storedDate = localStorage.getItem('counter_today_date');
    const storedTodayViews = localStorage.getItem('counter_today_views');

    if (storedDate === today && storedTodayViews) {
      const views = parseInt(storedTodayViews, 10);
      setTodayViews(views + 1);
      localStorage.setItem('counter_today_views', (views + 1).toString());
    } else {
      // 新しい日
      setTodayViews(1);
      localStorage.setItem('counter_today_date', today);
      localStorage.setItem('counter_today_views', '1');
    }

    // 累計アクセス数
    const storedTotalViews = localStorage.getItem('counter_total_views');
    if (storedTotalViews) {
      const total = parseInt(storedTotalViews, 10);
      setTotalViews(total + 1);
      localStorage.setItem('counter_total_views', (total + 1).toString());
    } else {
      // 初回訪問時は100-500のランダム値で初期化
      const initialTotal = Math.floor(Math.random() * 401) + 100;
      setTotalViews(initialTotal);
      localStorage.setItem('counter_total_views', initialTotal.toString());
    }

    return () => clearInterval(activeUsersInterval);
  }, []);

  const formatNumber = (num: number): string => {
    return num.toLocaleString('ja-JP');
  };

  const nextFacilitySlide = () => {
    if (facilityScrollRef.current) {
      const container = facilityScrollRef.current;
      const cardWidth = container.offsetWidth;
      const newSlide = (facilitySlide + 1) % 9;
      setFacilitySlide(newSlide);
      container.scrollTo({
        left: cardWidth * newSlide,
        behavior: 'smooth'
      });
    }
  };

  const prevFacilitySlide = () => {
    if (facilityScrollRef.current) {
      const container = facilityScrollRef.current;
      const cardWidth = container.offsetWidth;
      const newSlide = facilitySlide === 0 ? 8 : facilitySlide - 1;
      setFacilitySlide(newSlide);
      container.scrollTo({
        left: cardWidth * newSlide,
        behavior: 'smooth'
      });
    }
  };

  const nextBookingFlowSlide = () => {
    if (bookingFlowScrollRef.current) {
      const container = bookingFlowScrollRef.current;
      const cardWidth = container.offsetWidth;
      const newSlide = (bookingFlowSlide + 1) % 4;
      setBookingFlowSlide(newSlide);
      container.scrollTo({
        left: cardWidth * newSlide,
        behavior: 'smooth'
      });
    }
  };

  const prevBookingFlowSlide = () => {
    if (bookingFlowScrollRef.current) {
      const container = bookingFlowScrollRef.current;
      const cardWidth = container.offsetWidth;
      const newSlide = bookingFlowSlide === 0 ? 3 : bookingFlowSlide - 1;
      setBookingFlowSlide(newSlide);
      container.scrollTo({
        left: cardWidth * newSlide,
        behavior: 'smooth'
      });
    }
  };

  const nextTransportSlide = () => {
    if (transportScrollRef.current) {
      const container = transportScrollRef.current;
      const cardWidth = container.offsetWidth;
      const newSlide = (transportSlide + 1) % 2;
      setTransportSlide(newSlide);
      container.scrollTo({
        left: cardWidth * newSlide,
        behavior: 'smooth'
      });
    }
  };

  const prevTransportSlide = () => {
    if (transportScrollRef.current) {
      const container = transportScrollRef.current;
      const cardWidth = container.offsetWidth;
      const newSlide = transportSlide === 0 ? 1 : transportSlide - 1;
      setTransportSlide(newSlide);
      container.scrollTo({
        left: cardWidth * newSlide,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* 言語切り替えボタン - 右上固定 */}
      <div className="fixed top-4 right-4 z-50">
        <LanguageSwitcher />
      </div>

      {/* ヒーローセクション */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* PC版: 動画背景のみ */}
        <video
          autoPlay
          muted
          loop
          playsInline
          className="hidden md:block absolute inset-0 w-full h-full object-cover"
          style={{ objectFit: 'cover' }}
        >
          <source src="https://wqoajmibmkybfwtnudhh.supabase.co/storage/v1/object/public/hero-video/GuestHouse017osaka.top.mp4" type="video/mp4" />
        </video>

        {/* PC版: 動画が読み込めない場合のフォールバック画像 */}
        <div 
          className="hidden md:block absolute inset-0 bg-cover bg-center -z-10"
          style={{
            backgroundImage: `url('https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/a0c61036c5d91b6415c49ff92327e314.png')`
          }}
        />

        {/* スマホ版: 既存の静止画像 */}
        <div 
          className="md:hidden absolute inset-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url('https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/b4bdc0d9dce02722cac158f55d06e937.jpeg')`
          }}
        />

        {/* コンテンツ */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        </div>
      </section>

      {/* Google レビューバナー & お客様の声 */}
      <section className="py-8 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          {/* PC版：予約ボタン */}
          <div className="hidden md:flex justify-center mb-8">
            <Link
              to="/reservation"
              className="bg-gradient-to-r from-teal-500 to-cyan-600 text-white px-12 py-4 rounded-full text-lg font-bold hover:from-teal-600 hover:to-cyan-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap w-full max-w-[600px] text-center"
            >
              ご予約はこちら
            </Link>
          </div>

          {/* カウンターバー - PC版のみ */}
          <div className="hidden md:flex justify-center mb-8">
            <div className="w-full max-w-[800px] bg-white rounded-2xl border border-gray-200 shadow-sm px-8 py-6">
              <div className="grid grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="flex items-center justify-center gap-2 mb-2">
                    <i className="ri-eye-line text-xl text-gray-600"></i>
                    <p className="text-sm text-gray-600 font-medium">現在の閲覧者数</p>
                  </div>
                  <p id="counter-current" className="text-3xl font-bold text-gray-800">{formatNumber(activeUsers)}</p>
                </div>
                <div className="text-center border-l border-r border-gray-200">
                  <div className="flex items-center justify-center gap-2 mb-2">
                    <i className="ri-calendar-line text-xl text-gray-600"></i>
                    <p className="text-sm text-gray-600 font-medium">本日の閲覧数</p>
                  </div>
                  <p id="counter-today" className="text-3xl font-bold text-gray-800">{formatNumber(todayViews)}</p>
                </div>
                <div className="text-center">
                  <div className="flex items-center justify-center gap-2 mb-2">
                    <i className="ri-bar-chart-line text-xl text-gray-600"></i>
                    <p className="text-sm text-gray-600 font-medium">累計アクセス数</p>
                  </div>
                  <p id="counter-total" className="text-3xl font-bold text-gray-800">{formatNumber(totalViews)}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="hidden md:grid md:grid-cols-2 gap-6 items-stretch">
            <div className="min-h-[400px]">
              <GoogleReviewBanner rating={4.7} />
            </div>

            <div className="relative flex flex-col justify-center h-full min-h-[400px]">
              <button
                onClick={prevSlide}
                className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer"
                aria-label="前のレビュー"
              >
                <i className="ri-arrow-left-s-line text-2xl text-gray-700"></i>
              </button>

              <div 
                ref={scrollContainerRef}
                className="overflow-hidden h-full"
              >
                <div 
                  className="flex transition-transform duration-500 ease-in-out h-full"
                  style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                >
                  {reviews.map((review, index) => (
                    <div key={index} className="w-full flex-shrink-0 px-4 flex items-center h-full">
                      <div 
                        className={`bg-gradient-to-br ${review.bgColor} p-8 rounded-2xl shadow-md hover:shadow-xl transition-all border ${review.borderColor} w-full h-full flex flex-col justify-center ${
                          currentSlide === index ? 'animate-zoom-in' : ''
                        }`}
                      >
                        <div className="flex items-center justify-center gap-1 mb-6">
                          {[1, 2, 3, 4, 5].map((star) => (
                            <i key={star} className={`${star <= Math.floor(review.rating) ? 'ri-star-fill' : review.rating >= star - 0.5 ? 'ri-star-half-fill' : 'ri-star-line'} text-yellow-400 text-4xl`}></i>
                          ))}
                        </div>

                        <p className="text-gray-700 leading-relaxed mb-6 text-xl px-12">
                          {review.text}
                        </p>

                        <div className="flex items-center justify-center gap-3">
                          <div className={`w-10 h-10 bg-gradient-to-br ${review.color} rounded-full flex items-center justify-center text-white font-bold text-sm`}>
                            {review.name.charAt(0)}
                          </div>
                          <div>
                            <p className="font-bold text-slate-800 text-2xl">{review.name}</p>
                            <p className="text-base text-gray-500">{review.type}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <button
                onClick={nextSlide}
                className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer"
                aria-label="次のレビュー"
              >
                <i className="ri-arrow-right-s-line text-2xl text-gray-700"></i>
              </button>
            </div>
          </div>

          <div className="md:hidden relative">
            <button
              onClick={prevMobileSlide}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer"
              aria-label="前のスライド"
            >
              <i className="ri-arrow-left-s-line text-xl text-gray-700"></i>
            </button>

            <div 
              ref={mobileScrollRef}
              className="overflow-hidden h-[300px]"
            >
              <div 
                className="flex transition-transform duration-500 ease-in-out h-full"
                style={{ transform: `translateX(-${mobileSlide * 100}%)` }}
              >
                {mobileSlides.map((slide, index) => (
                  <div key={index} className="w-full flex-shrink-0 px-2 flex items-center justify-center h-full">
                    <div className={`w-full h-full ${mobileSlide === index ? 'animate-zoom-in' : ''}`}>
                      {slide.content}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button
              onClick={nextMobileSlide}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer"
              aria-label="次のスライド"
            >
              <i className="ri-arrow-right-s-line text-xl text-gray-700"></i>
            </button>

            <div className="flex items-center justify-center gap-2 mt-4">
              {mobileSlides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => {
                    setMobileSlide(index);
                    if (mobileScrollRef.current) {
                      const container = mobileScrollRef.current;
                      const cardWidth = container.offsetWidth;
                      container.scrollTo({
                        left: cardWidth * index,
                        behavior: 'smooth'
                      });
                    }
                  }}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    mobileSlide === index ? 'bg-blue-600 w-6' : 'bg-gray-300'
                  }`}
                  aria-label={`スライド${index + 1}へ移動`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 選ばれる6つの理由 - 横スクロールアニメーション */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-teal-50 via-white to-cyan-50 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4">選ばれる6つの理由</h2>
          </div>

          {/* 横スクロールアニメーション */}
          <div className="relative">
            <div className="animate-scroll-fast flex gap-6">
              {/* 1セット目 */}
              <div className="flex gap-6 flex-shrink-0">
                {reasons.map((reason, index) => (
                  <div
                    key={`set1-${index}`}
                    className="w-80 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 flex-shrink-0"
                  >
                    <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl flex items-center justify-center mb-6 shadow-md">
                      <i className={`${reason.icon} text-3xl text-white`}></i>
                    </div>
                    <h3 className="text-2xl font-bold mb-4 text-gray-900">{reason.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{reason.description}</p>
                  </div>
                ))}
              </div>
              {/* 2セット目（シームレスなループ用） */}
              <div className="flex gap-6 flex-shrink-0">
                {reasons.map((reason, index) => (
                  <div
                    key={`set2-${index}`}
                    className="w-80 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 flex-shrink-0"
                  >
                    <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl flex items-center justify-center mb-6 shadow-md">
                      <i className={`${reason.icon} text-3xl text-white`}></i>
                    </div>
                    <h3 className="text-2xl font-bold mb-4 text-gray-900">{reason.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{reason.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <style>{`
            @keyframes scroll-fast {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(calc(-320px * 6 - 24px * 6));
              }
            }
            
            .animate-scroll-fast {
              animation: scroll-fast 20s linear infinite;
            }
            
            .animate-scroll-fast:hover {
              animation-play-state: paused;
            }
          `}</style>
        </div>
      </section>

      {/* 客室紹介 */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-3 md:mb-6 text-slate-800">
            客室紹介
          </h2>
          <p className="text-center text-gray-600 mb-8 md:mb-16 text-base sm:text-lg">
            和洋室6室をご用意。グループ内でもプライバシーを確保できます
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/226cee8b06a2cce965ee87cf0526cb35.jpeg"
                  alt="3階301室"
                  className="w-full h-64 object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-bold">
                  和室
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">3階301室(ダブル1+シングル2)</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  テレビ、テーブル、椅子のあるシンプルで居心地の良い和室
                </p>
                <div className="flex items-center gap-4 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <i className="ri-user-line text-blue-600"></i>
                    <span>4名様まで</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/3365aefbed673239c884467043c30d95.jpeg"
                  alt="3階302室"
                  className="w-full h-64 object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-bold">
                  和室
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">3階302室(ダブル2+シングル1)</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  ローテーブルと冷蔵庫を備えた広々とした和室で、ゆったりくつろげる空間
                </p>
                <div className="flex items-center gap-4 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <i className="ri-user-line text-blue-600"></i>
                    <span>5名様まで</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/c294d7865c2436ee0d6aad5fea3bf709.jpeg"
                  alt="4階401室"
                  className="w-full h-64 object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-bold">
                  和室
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">4階401室(ダブル1+シングル2)</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  テレビ、テーブル、椅子のあるシンプル和室、畳のやわらかさと落ち着いた空間
                </p>
                <div className="flex items-center gap-4 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <i className="ri-user-line text-blue-600"></i>
                    <span>4名様まで</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/7f6c44ae784d541b1c99d5239ac4323c.jpeg"
                  alt="4階402室 - 和室"
                  className="w-full h-64 object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-bold">
                  和室
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">4階402室(ダブル2+シングル2)</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  テレビ、冷蔵庫付きで寝室の窓外には小さなベランダがあるので喫煙可能、街の景色が楽しめるくつろぎ空間
                </p>
                <div className="flex items-center gap-4 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <i className="ri-user-line text-blue-600"></i>
                    <span>6名様まで</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/9876a9fdb025eb37efafd574b7a94862.jpeg"
                  alt="客室5 - 洋室"
                  className="w-full h-64 object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-bold">
                  洋室
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">客室5(ダブル1+シングル1)</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  ソファ、冷蔵庫、収納に便利なワードローブ付き、ベッドタイプの洋室で明るく落ち着いた空間
                </p>
                <div className="flex items-center gap-4 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <i className="ri-user-line text-blue-600"></i>
                    <span>3名様まで</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/d200fa779d5bee958b1d50f3072002a4.jpeg"
                  alt="客室6 - 洋室"
                  className="w-full h-64 object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-amber-600 text-white px-4 py-2 rounded-full text-sm font-bold">
                  洋室
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">客室6(ダブル1+セミダブル1)</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  ソファ付き、広めのベランダは日当たりが良く、洗濯機、テーブルと椅子付き、喫煙も可能。街の景色が楽しめるくつろぎ空間
                </p>
                <div className="flex items-center gap-4 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <i className="ri-user-line text-blue-600"></i>
                    <span>3〜4名様まで</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 施設紹介 */}
      <section className="py-8 md:py-20 bg-slate-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-12 md:mb-16 text-slate-800">
            充実の設備・アメニティー
          </h2>
          
          {/* PC版: グリッド表示 */}
          <div className="hidden md:grid md:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/511d4e8d41c6811bf6589204f22ae1e4.jpeg"
                alt="玄関入口"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">玄関入口</h3>
                <p className="text-gray-600 leading-relaxed">
                  スリッパ、旅行パンフレットや地図も用意、大阪観光の計画にも便利
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/33637d0ae5058bd7a8673c54c71dcb5c.jpeg"
                alt="ダイニングエリア"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">ダイニングエリア</h3>
                <p className="text-gray-600 leading-relaxed">
                  浄水機付き、無料コーヒー＆ソファでゆったり過ごせる共有スペース。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/01fc90446f062a3bdcbdce558fcac92c.jpeg"
                alt="キッチン"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">キッチン</h3>
                <p className="text-gray-600 leading-relaxed">
                  自炊OK！調理器具・食器・調味料フル完備。長期滞在にも便利
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/11770b20ce05081c42b8ae5968f518ff.jpeg"
                alt="ベランダ"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">ベランダ</h3>
                <p className="text-gray-600 leading-relaxed">
                  開放的な喫煙エリア、テーブル、椅子付き。洗濯機・物干し利用可能。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/9ca67bbf8050ccfa0d6b2343540a2351.jpeg"
                alt="バスルーム"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">バスルーム</h3>
                <p className="text-gray-600 leading-relaxed">
                  ２階エリアにあり、ゆったりバスで旅の疲れを癒せます。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/dd4ea70d5035e727d3bc6cd27ecc0214.jpeg"
                alt="シャワールーム"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">シャワールーム</h3>
                <p className="text-gray-600 leading-relaxed">
                  3階4階は独立シャワー×2で朝も混雑しません。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/5a6eedeab69ff7a64071ca993cc78fc2.jpeg"
                alt="各階フロア"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">各階フロア</h3>
                <p className="text-gray-600 leading-relaxed">
                  洗面台・トイレと完備。バスタオル・タオルセットもご用意。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/00f324eaadd8f1465a46bb382ea4854b.jpeg"
                alt="トイレ"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">トイレ</h3>
                <p className="text-gray-600 leading-relaxed">
                  各階にあります、清潔なトイレ4室で大人数でも安心。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img 
                src="https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/b518002cd9896020317568cbd56cd04f.jpeg"
                alt="アメニティ"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-slate-800">アメニティ</h3>
                <p className="text-gray-600 leading-relaxed">
                  歯ブラシ・くし・タオル・シャンプ・リンス・ドライヤーなど必需品を全て揃い
                </p>
              </div>
            </div>
          </div>

          {/* スマホ版: 自動横スクロールアニメーション */}
          <div className="md:hidden relative overflow-hidden">
            <style dangerouslySetInnerHTML={{
              __html: `
                @keyframes scroll-facilities {
                  0% {
                    transform: translateX(0);
                  }
                  100% {
                    transform: translateX(calc(-320px * 9 - 24px * 9));
                  }
                }
                
                .animate-scroll-facilities {
                  animation: scroll-facilities 45s linear infinite;
                }
                
                .animate-scroll-facilities:hover {
                  animation-play-state: paused;
                }
              `
            }} />
            
            <div className="flex animate-scroll-facilities gap-6">
              {/* 1セット目 */}
              <div className="flex gap-6 flex-shrink-0">
                {[
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/511d4e8d41c6811bf6589204f22ae1e4.jpeg",
                    title: "玄関入口",
                    desc: "スリッパ、旅行パンフレットや地図も用意、大阪観光の計画にも便利"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/33637d0ae5058bd7a8673c54c71dcb5c.jpeg",
                    title: "ダイニングエリア",
                    desc: "浄水機付き、無料コーヒー＆ソファでゆったり過ごせる共有スペース。"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/01fc90446f062a3bdcbdce558fcac92c.jpeg",
                    title: "キッチン",
                    desc: "自炊OK！調理器具・食器・調味料フル完備。長期滞在にも便利"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/11770b20ce05081c42b8ae5968f518ff.jpeg",
                    title: "ベランダ",
                    desc: "開放的な喫煙エリア、テーブル、椅子付き。洗濯機・物干し利用可能。"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/9ca67bbf8050ccfa0d6b2343540a2351.jpeg",
                    title: "バスルーム",
                    desc: "２階エリアにあり、ゆったりバスで旅の疲れを癒せます。"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/dd4ea70d5035e727d3bc6cd27ecc0214.jpeg",
                    title: "シャワールーム",
                    desc: "3階4階は独立シャワー×2で朝も混雑しません。"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/5a6eedeab69ff7a64071ca993cc78fc2.jpeg",
                    title: "各階フロア",
                    desc: "洗面台・トイレと完備。バスタオル・タオルセットもご用意。"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/00f324eaadd8f1465a46bb382ea4854b.jpeg",
                    title: "トイレ",
                    desc: "各階にあります、清潔なトイレ4室で大人数でも安心。"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/b518002cd9896020317568cbd56cd04f.jpeg",
                    title: "アメニティ",
                    desc: "歯ブラシ・くし・タオル・シャンプ・リンス・ドライヤーなど必需品を全て揃い"
                  }
                ].map((facility, index) => (
                  <div
                    key={`set1-${index}`}
                    className="w-80 bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow flex-shrink-0"
                  >
                    <img 
                      src={facility.img}
                      alt={facility.title}
                      className="w-full h-64 object-cover object-top"
                    />
                    <div className="p-6">
                      <h3 className="text-xl font-bold mb-3 text-slate-800">{facility.title}</h3>
                      <p className="text-gray-600 leading-relaxed">
                        {facility.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
              
              {/* 2セット目（シームレスなループ用） */}
              <div className="flex gap-6 flex-shrink-0">
                {[
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/511d4e8d41c6811bf6589204f22ae1e4.jpeg",
                    title: "玄関入口",
                    desc: "スリッパ、旅行パンフレットや地図も用意、大阪観光の計画にも便利"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/33637d0ae5058bd7a8673c54c71dcb5c.jpeg",
                    title: "ダイニングエリア",
                    desc: "浄水機付き、無料コーヒー＆ソファでゆったり過ごせる共有スペース。"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/01fc90446f062a3bdcbdce558fcac92c.jpeg",
                    title: "キッチン",
                    desc: "自炊OK！調理器具・食器・調味料フル完備。長期滞在にも便利"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/11770b20ce05081c42b8ae5968f518ff.jpeg",
                    title: "ベランダ",
                    desc: "開放的な喫煙エリア、テーブル、椅子付き。洗濯機・物干し利用可能。"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/9ca67bbf8050ccfa0d6b2343540a2351.jpeg",
                    title: "バスルーム",
                    desc: "２階エリアにあり、ゆったりバスで旅の疲れを癒せます。"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/dd4ea70d5035e727d3bc6cd27ecc0214.jpeg",
                    title: "シャワールーム",
                    desc: "3階4階は独立シャワー×2で朝も混雑しません。"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/5a6eedeab69ff7a64071ca993cc78fc2.jpeg",
                    title: "各階フロア",
                    desc: "洗面台・トイレと完備。バスタオル・タオルセットもご用意。"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/00f324eaadd8f1465a46bb382ea4854b.jpeg",
                    title: "トイレ",
                    desc: "各階にあります、清潔なトイレ4室で大人数でも安心。"
                  },
                  {
                    img: "https://static.readdy.ai/image/532992a9a7b892cdbfcbe570165d1ee5/b518002cd9896020317568cbd56cd04f.jpeg",
                    title: "アメニティ",
                    desc: "歯ブラシ・くし・タオル・シャンプ・リンス・ドライヤーなど必需品を全て揃い"
                  }
                ].map((facility, index) => (
                  <div
                    key={`set2-${index}`}
                    className="w-80 bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow flex-shrink-0"
                  >
                    <img 
                      src={facility.img}
                      alt={facility.title}
                      className="w-full h-64 object-cover object-top"
                    />
                    <div className="p-6">
                      <h3 className="text-xl font-bold mb-3 text-slate-800">{facility.title}</h3>
                      <p className="text-gray-600 leading-relaxed">
                        {facility.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 空港送迎・チャーター配車サービス */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-blue-500 to-cyan-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-4 md:mb-6 text-slate-800">
            <span className="md:hidden">空港・観光地の送迎<br />チャーター配車サービス</span>
            <span className="hidden md:inline">空港送迎・チャーター配車サービス</span>
          </h2>
          <p className="text-center text-gray-600 mb-12 md:mb-16 text-base sm:text-lg">
            快適な移動をサポートいたします
          </p>
          
          {/* PC版: 2列グリッド */}
          <div className="hidden md:grid md:grid-cols-2 gap-8 md:gap-12 mb-12">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-plane-line text-4xl text-blue-600"></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold mb-4 text-center text-slate-800">チャーター送迎サービス</h3>
              <p className="text-gray-600 leading-relaxed mb-6 text-center">
                関西国際空港・伊丹空港・USJなど主要な観光地や空港から当施設まで、ドア・ツー・ドアで快適に移動できる<br />
                チャーター送迎サービスをご提供しています
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mr-2 mt-1 flex-shrink-0"></i>
                  <span>関西国際空港・伊丹空港・各観光地に対応</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mr-2 mt-1 flex-shrink-0"></i>
                  <span>大人数グループも安心</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mr-2 mt-1 flex-shrink-0"></i>
                  <span>荷物が多い方でも快適に移動可能</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-car-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl sm:text-2xl font-bold mb-4 text-center text-slate-800">チャーター配車サービス</h3>
              <p className="text-gray-600 leading-relaxed mb-6 text-center">
                大阪・京都・奈良・神戸をはじめ全国の観光地へ対応した、自由度の高いチャーター配車サービスを提供します。お客様のご希望に合わせた観光プランで、快適で安心な旅をサポートします
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mr-2 mt-1 flex-shrink-0"></i>
                  <span>全国対応</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mr-2 mt-1 flex-shrink-0"></i>
                  <span>自由な観光プランに対応</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-green-500 mr-2 mt-1 flex-shrink-0"></i>
                  <span>正規会社の経験豊富なドライバーが担当</span>
                </li>
              </ul>
            </div>
          </div>

          {/* スマホ版: スライド表示 */}
          <div className="md:hidden relative mb-12">
            <button
              onClick={prevTransportSlide}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer"
              aria-label="前へ"
            >
              <i className="ri-arrow-left-s-line text-xl text-gray-700"></i>
            </button>

            <div 
              ref={transportScrollRef}
              className="overflow-hidden"
            >
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${transportSlide * 100}%)` }}
              >
                <div className="w-full flex-shrink-0 px-4">
                  <div className="bg-white rounded-2xl p-6 shadow-lg">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-plane-line text-3xl text-blue-600"></i>
                    </div>
                    <h3 className="text-lg font-bold mb-3 text-slate-800">チャーター送迎サービス</h3>
                    <p className="text-gray-600 leading-relaxed mb-4 text-sm text-center">
                      関西国際空港・伊丹空港・各観光地に対応した、ドア・ツー・ドアで快適に移動できるチャーター送迎サービスをご提供しています
                    </p>
                    <ul className="space-y-2 text-gray-700 text-sm">
                      <li className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>関西国際空港・伊丹空港・各観光地に対応</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>大人数グループも安心</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>荷物が多い方でも快適に移動可能</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="w-full flex-shrink-0 px-4">
                  <div className="bg-white rounded-2xl p-6 shadow-lg">
                    <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-car-line text-3xl text-teal-600"></i>
                    </div>
                    <h3 className="text-lg font-bold mb-3 text-slate-800">チャーター配車サービス</h3>
                    <p className="text-gray-600 leading-relaxed mb-4 text-sm text-center">
                      大阪・京都・奈良・神戸をはじめ全国の観光地へ対応した、自由度の高いチャーター配車サービスを提供します。お客様のご希望に合わせた観光プランで、快適で安心な旅をサポートします
                    </p>
                    <ul className="space-y-2 text-gray-700 text-sm">
                      <li className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>全国対応</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>自由な観光プランに対応</span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-2 mt-0.5 flex-shrink-0"></i>
                        <span>正規会社の経験豊富なドライバーが担当</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <button
              onClick={nextTransportSlide}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer"
              aria-label="次へ"
            >
              <i className="ri-arrow-right-s-line text-xl text-gray-700"></i>
            </button>

            <div className="flex items-center justify-center gap-2 mt-6">
              {[0, 1].map((index) => (
                <button
                  key={index}
                  onClick={() => {
                    setTransportSlide(index);
                    if (transportScrollRef.current) {
                      const container = transportScrollRef.current;
                      const cardWidth = container.offsetWidth;
                      container.scrollTo({
                        left: cardWidth * index,
                        behavior: 'smooth'
                      });
                    }
                  }}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    transportSlide === index ? 'bg-blue-600 w-6' : 'bg-gray-300'
                  }`}
                  aria-label={`スライド${index + 1}へ移動`}
                />
              ))}
            </div>
          </div>

          <div className="text-center">
            <a
              href={transportFormUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-gradient-to-r from-blue-500 to-cyan-600 text-white px-8 sm:px-12 py-3 sm:py-4 rounded-full text-base sm:text-lg font-bold hover:from-blue-600 hover:to-cyan-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              配車サービスお問い合わせ
            </a>
          </div>
        </div>
      </section>

      {/* 利用シーン紹介 */}
      <section className="py-16 md:py-20 bg-gradient-to-b from-blue-50 to-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-4 md:mb-6 text-slate-800">
            こんなグループにおすすめ
          </h2>
          <p className="text-center text-gray-600 mb-12 md:mb-16 text-base sm:text-lg">
            様々なシーンでご利用いただけます
          </p>
          
          {/* PC版: グリッド表示 */}
          <div className="hidden md:grid md:grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow">
              <div className="h-56 bg-gradient-to-br from-pink-100 to-pink-50 flex items-center justify-center">
                <i className="ri-parent-line text-7xl text-pink-500"></i>
              </div>
              <div className="p-8">
                <h4 className="font-bold text-2xl mb-4 text-slate-800">家族旅行</h4>
                <p className="text-gray-600 leading-relaxed text-lg">
                  三世代家族での旅行や親戚の集まりに。みんなで一緒に過ごせます。
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow">
              <div className="h-56 bg-gradient-to-br from-blue-100 to-blue-50 flex items-center justify-center">
                <i className="ri-basketball-line text-7xl text-blue-500"></i>
              </div>
              <div className="p-8">
                <h4 className="font-bold text-2xl mb-4 text-slate-800">部活・遠征</h4>
                <p className="text-gray-600 leading-relaxed text-lg">
                  スポーツチームの遠征や合宿に最適。チームの絆も深まります。
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow">
              <div className="h-56 bg-gradient-to-br from-green-100 to-green-50 flex items-center justify-center">
                <i className="ri-group-line text-7xl text-green-500"></i>
              </div>
              <div className="p-8">
                <h4 className="font-bold text-2xl mb-4 text-slate-800">サークル旅行</h4>
                <p className="text-gray-600 leading-relaxed text-lg">
                  大学のサークルやグループ旅行に。思い出に残る時間を。
                </p>
              </div>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow">
              <div className="h-56 bg-gradient-to-br from-amber-100 to-amber-50 flex items-center justify-center">
                <i className="ri-goblet-line text-7xl text-amber-500"></i>
              </div>
              <div className="p-8">
                <h4 className="font-bold text-2xl mb-4 text-slate-800">同窓会</h4>
                <p className="text-gray-600 leading-relaxed text-lg">
                  懐かしい仲間との再会に。ゆっくり語り合える空間です。
                </p>
              </div>
            </div>
          </div>

          {/* スマホ版: スライド表示 */}
          <div className="md:hidden relative">
            {/* 左矢印 */}
            <button
              onClick={() => {
                const container = document.getElementById('use-case-slide-container');
                if (container) {
                  const currentScroll = container.scrollLeft;
                  const cardWidth = container.offsetWidth;
                  container.scrollTo({ left: currentScroll - cardWidth, behavior: 'smooth' });
                }
              }}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer"
              aria-label="前へ"
            >
              <i className="ri-arrow-left-s-line text-xl text-gray-700"></i>
            </button>

            {/* スライドコンテナ */}
            <div 
              id="use-case-slide-container"
              className="overflow-x-auto snap-x snap-mandatory scrollbar-hide"
              style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
              <div className="flex gap-4 px-2">
                {/* カード1 */}
                <div className="flex-shrink-0 w-full snap-start">
                  <div className="bg-white rounded-2xl overflow-hidden shadow-md">
                    <div className="h-56 bg-gradient-to-br from-pink-100 to-pink-50 flex items-center justify-center">
                      <i className="ri-parent-line text-7xl text-pink-500"></i>
                    </div>
                    <div className="p-8">
                      <h4 className="font-bold text-2xl mb-4 text-slate-800">家族旅行</h4>
                      <p className="text-gray-600 leading-relaxed text-lg">
                        三世代家族での旅行や親戚の集まりに。みんなで一緒に過ごせます。
                      </p>
                    </div>
                  </div>
                </div>

                {/* カード2 */}
                <div className="flex-shrink-0 w-full snap-start">
                  <div className="bg-white rounded-2xl overflow-hidden shadow-md">
                    <div className="h-56 bg-gradient-to-br from-blue-100 to-blue-50 flex items-center justify-center">
                      <i className="ri-basketball-line text-7xl text-blue-500"></i>
                    </div>
                    <div className="p-8">
                      <h4 className="font-bold text-2xl mb-4 text-slate-800">部活・遠征</h4>
                      <p className="text-gray-600 leading-relaxed text-lg">
                        スポーツチームの遠征や合宿に最適。チームの絆も深まります。
                      </p>
                    </div>
                  </div>
                </div>

                {/* カード3 */}
                <div className="flex-shrink-0 w-full snap-start">
                  <div className="bg-white rounded-2xl overflow-hidden shadow-md">
                    <div className="h-56 bg-gradient-to-br from-green-100 to-green-50 flex items-center justify-center">
                      <i className="ri-group-line text-7xl text-green-500"></i>
                    </div>
                    <div className="p-8">
                      <h4 className="font-bold text-2xl mb-4 text-slate-800">サークル旅行</h4>
                      <p className="text-gray-600 leading-relaxed text-lg">
                        大学のサークルやグループ旅行に。思い出に残る時間を。
                      </p>
                    </div>
                  </div>
                </div>

                {/* カード4 */}
                <div className="flex-shrink-0 w-full snap-start">
                  <div className="bg-white rounded-2xl overflow-hidden shadow-md">
                    <div className="h-56 bg-gradient-to-br from-amber-100 to-amber-50 flex items-center justify-center">
                      <i className="ri-goblet-line text-7xl text-amber-500"></i>
                    </div>
                    <div className="p-8">
                      <h4 className="font-bold text-2xl mb-4 text-slate-800">同窓会</h4>
                      <p className="text-gray-600 leading-relaxed text-lg">
                        懐かしい仲間との再会に。ゆっくり語り合える空間です。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 右矢印 */}
            <button
              onClick={() => {
                const container = document.getElementById('use-case-slide-container');
                if (container) {
                  const currentScroll = container.scrollLeft;
                  const cardWidth = container.offsetWidth;
                  container.scrollTo({ left: currentScroll + cardWidth, behavior: 'smooth' });
                }
              }}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer"
              aria-label="次へ"
            >
              <i className="ri-arrow-right-s-line text-xl text-gray-700"></i>
            </button>

            {/* インジケーター */}
            <div className="flex justify-center items-center mt-6 gap-2">
              {[0, 1, 2, 3].map((index) => (
                <button
                  key={index}
                  onClick={() => {
                    const container = document.getElementById('use-case-slide-container');
                    if (container) {
                      const cardWidth = container.offsetWidth;
                      container.scrollTo({ left: cardWidth * index, behavior: 'smooth' });
                    }
                  }}
                  className="w-2 h-2 rounded-full bg-gray-300 transition-all cursor-pointer"
                  aria-label={`スライド${index + 1}へ移動`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 料金イメージ */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-12 md:mb-16 text-slate-800">
            お得な料金システム
          </h2>
          <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-3xl p-6 sm:p-8 md:p-10 shadow-lg">
            <div className="text-center mb-6 md:mb-8">
              <i className="ri-money-dollar-circle-line text-5xl md:text-6xl text-amber-600 mb-4"></i>
              <h3 className="text-xl sm:text-2xl font-bold mb-3 md:mb-4 text-slate-800">人数で割るとさらにお得!</h3>
              <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
                一棟貸切だから、人数が多いほど1人あたりの料金がお安くなります。<br className="hidden sm:block" />
                ホテルより安く、広々とした空間を楽しめます。
              </p>
            </div>
            <div className="bg-white rounded-2xl p-6 md:p-8 mb-4 md:mb-6">
              <div className="flex items-center justify-center gap-3 md:gap-4 mb-4">
                <i className="ri-group-2-line text-2xl md:text-3xl text-blue-600"></i>
                <p className="text-base sm:text-lg text-gray-700">
                  <strong className="text-slate-800">例:</strong> 15名で利用した場合、1人あたりの料金は驚くほどリーズナブルに!
                </p>
              </div>
            </div>
            <div className="text-center">
              <p className="text-gray-700 mb-4 md:mb-6 text-base sm:text-lg">
                詳しい料金は、ご利用人数・日程によって異なります。<br />
                <strong className="font-bold">まずはお気軽にご相談ください</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ご予約・お問い合わせの流れ */}
      <section className="py-16 md:py-20 bg-slate-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-12 md:mb-16 text-slate-800">
            ご予約・お問い合わせの流れ
          </h2>
          
          {/* PC版: グリッド表示 */}
          <div className="hidden md:grid md:grid-cols-4 gap-6 md:gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-green-600 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-2xl font-bold shadow-lg">
                1
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-md h-48 flex flex-col justify-center">
                <i className="ri-line-fill text-4xl text-green-500 mb-3"></i>
                <h4 className="font-bold text-lg mb-2 text-slate-800">Talk with Us に連絡</h4>
                <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
                  右下のボタンからお問い合わせ
                </p>
              </div>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-2xl font-bold shadow-lg">
                2
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-md h-48 flex flex-col justify-center">
                <i className="ri-calendar-check-line text-4xl text-blue-500 mb-3"></i>
                <h4 className="font-bold text-lg mb-2 text-slate-800">日程と人数を送信</h4>
                <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
                  希望日と人数をお知らせください
                </p>
              </div>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-amber-600 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-2xl font-bold shadow-lg">
                3
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-md h-48 flex flex-col justify-center">
                <i className="ri-chat-smile-3-line text-4xl text-amber-500 mb-3"></i>
                <h4 className="font-bold text-lg mb-2 text-slate-800">空室と料金を案内</h4>
                <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
                  より早めのご予約をお勧めいたします
                </p>
              </div>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-purple-600 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-2xl font-bold shadow-lg">
                4
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-md h-48 flex flex-col justify-center">
                <i className="ri-checkbox-circle-line text-4xl text-purple-500 mb-3"></i>
                <h4 className="font-bold text-lg mb-2 text-slate-800">予約確定</h4>
                <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
                  詳細をご案内いたします
                </p>
              </div>
            </div>
          </div>

          {/* スマホ版: スライド表示 */}
          <div className="md:hidden relative">
            <button
              onClick={prevBookingFlowSlide}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer"
              aria-label="前へ"
            >
              <i className="ri-arrow-left-s-line text-xl text-gray-700"></i>
            </button>

            <div 
              ref={bookingFlowScrollRef}
              className="overflow-hidden"
            >
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${bookingFlowSlide * 100}%)` }}
              >
                {[
                  {
                    number: 1,
                    bgColor: 'bg-green-600',
                    icon: 'ri-line-fill',
                    iconColor: 'text-green-500',
                    title: 'Talk with Us に連絡',
                    desc: '右下のボタンからお問い合わせ'
                  },
                  {
                    number: 2,
                    bgColor: 'bg-blue-600',
                    icon: 'ri-calendar-check-line',
                    iconColor: 'text-blue-500',
                    title: '日程と人数を送信',
                    desc: '希望日と人数をお知らせください'
                  },
                  {
                    number: 3,
                    bgColor: 'bg-amber-600',
                    icon: 'ri-chat-smile-3-line',
                    iconColor: 'text-amber-500',
                    title: '空室と料金を案内',
                    desc: 'より早めのご予約をお勧めいたします'
                  },
                  {
                    number: 4,
                    bgColor: 'bg-purple-600',
                    icon: 'ri-checkbox-circle-line',
                    iconColor: 'text-purple-500',
                    title: '予約確定',
                    desc: '詳細をご案内いたします'
                  }
                ].map((step, index) => (
                  <div key={index} className="w-full flex-shrink-0 px-4">
                    <div className="text-center">
                      <div className={`w-20 h-20 ${step.bgColor} text-white rounded-full flex items-center justify-center mx-auto mb-6 text-2xl font-bold shadow-lg`}>
                        {step.number}
                      </div>
                      <div className="bg-white p-6 rounded-2xl shadow-md h-48 flex flex-col justify-center">
                        <i className={`${step.icon} text-4xl ${step.iconColor} mb-3`}></i>
                        <h4 className="font-bold text-lg mb-2 text-slate-800">{step.title}</h4>
                        <p className="text-gray-700 leading-relaxed text-base">
                          {step.desc}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button
              onClick={nextBookingFlowSlide}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer"
              aria-label="次へ"
            >
              <i className="ri-arrow-right-s-line text-xl text-gray-700"></i>
            </button>

            <div className="flex items-center justify-center gap-2 mt-6">
              {[0, 1, 2, 3].map((index) => (
                <button
                  key={index}
                  onClick={() => {
                    setBookingFlowSlide(index);
                    if (bookingFlowScrollRef.current) {
                      const container = bookingFlowScrollRef.current;
                      const cardWidth = container.offsetWidth;
                      container.scrollTo({
                        left: cardWidth * index,
                        behavior: 'smooth'
                      });
                    }
                  }}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    bookingFlowSlide === index ? 'bg-blue-600 w-6' : 'bg-gray-300'
                  }`}
                  aria-label={`ステップ${index + 1}へ移動`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* アクセス */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-12 md:mb-16 text-slate-800">
            アクセス
          </h2>
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <div className="bg-slate-50 p-8 rounded-2xl shadow-md mb-6">
                <h3 className="text-2xl font-bold mb-6 text-slate-800 flex items-center gap-3">
                  <i className="ri-map-pin-fill text-blue-600"></i>
                  所在地
                </h3>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                  <strong className="text-slate-800">Guesthouse017大阪</strong><br />
                  〒537-0024<br />
                  大阪府大阪市東成区東小橋3-14-10
                </p>
                <div className="border-t border-gray-200 pt-6">
                  <h4 className="font-bold mb-4 text-slate-800 flex items-center gap-2">
                    <i className="ri-train-line text-blue-600"></i>
                    最寄り駅
                  </h4>
                  <p className="text-gray-700 leading-relaxed">
                    <strong className="text-slate-800">JR・近鉄・大阪メトロ「鶴橋駅」</strong><br />
                    から徒歩約3分
                  </p>
                </div>
              </div>
              <div className="bg-blue-50 p-6 rounded-xl border-l-4 border-blue-500">
                <p className="text-gray-700 leading-relaxed">
                  <i className="ri-information-line text-blue-600 mr-2"></i>
                  駅から近く、3路線が利用できるので、大阪観光の計画にも便利です。
                </p>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg h-96">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.0!2d135.5367!3d34.6667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e0d0a0a0a0a0%3A0x0!2z5aSn6Ziq5bqc5p2x5oiQ5Yy65p2x5bCP5LiB55uu77yQ!5e0!3m2!1sja!2sjp!4v1700000000000!5m2!1sja!2sjp&q=大阪府大阪市東成区東小橋3-14-10"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Guesthouse017大阪の地図"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 md:py-20 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-12 md:mb-16 text-slate-800">
            よくあるご質問
          </h2>
          <div className="space-y-4">
            {[
              {
                q: '最大何名まで宿泊できますか?',
                a: '最大25名様までご宿泊いただけます。人数に応じて最適なお部屋の使い方をご提案いたしますので、まずはLINEでご相談ください。'
              },
              {
                q: '子ども料金はありますか?',
                a: 'お子様の年齢や人数によって料金が異なります。詳しくはLINEでお問い合わせください。お得なプランをご案内いたします。'
              },
              {
                q: '騒音は大丈夫ですか?',
                a: '一棟貸切なので、他のお客様を気にせずお過ごしいただけます。ただし、近隣への配慮をお願いしております。深夜の大声や騒音はお控えください。'
              },
              {
                q: 'チェックイン・チェックアウトの時間は?',
                a: 'チェックイン15:00、チェックアウト10:00が基本となります。時間の調整が必要な場合は、事前にご相談ください。'
              },
              {
                q: '駐車場はありますか?',
                a: '専用駐車場はございませんが、近隣にコインパーキングがございます。詳しい場所はご予約時にご案内いたします。'
              },
              {
                q: 'キャンセル料はかかりますか?',
                a: 'キャンセルポリシーについては、ご予約時に詳しくご説明いたします。まずはLINEでお気軽にお問い合わせください。'
              }
            ].map((faq, index) => (
              <div key={index} className="bg-white rounded-xl shadow-md overflow-hidden">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-4 sm:px-6 md:px-8 py-4 sm:py-5 md:py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <div className="flex items-start gap-3 md:gap-4 flex-1">
                    <div className="w-7 h-7 md:w-8 md:h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <span className="text-blue-600 font-bold text-sm md:text-base">Q</span>
                    </div>
                    <h4 className="font-bold text-base sm:text-lg text-slate-800 flex-1">{faq.q}</h4>
                  </div>
                  <i className={`ri-arrow-down-s-line text-xl md:text-2xl text-gray-400 transition-transform ${openFaq === index ? 'rotate-180' : ''}`}></i>
                </button>
                {openFaq === index && (
                  <div className="px-4 sm:px-6 md:px-8 pb-4 sm:pb-5 md:pb-6 pl-10 sm:pl-16 md:pl-20">
                    <div className="flex items-start gap-3 md:gap-4">
                      <div className="w-7 h-7 md:w-8 md:h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                        <span className="text-green-600 font-bold text-sm md:text-base">A</span>
                      </div>
                      <p className="text-gray-700 leading-relaxed flex-1 text-sm sm:text-base">{faq.a}</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 最後の問い合わせセクション */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 md:mb-6">
            まずは日程と人数だけでも<br />お気軽にご相談ください
          </h2>
          <p className="text-lg sm:text-xl mb-8 md:mb-10 text-blue-100 leading-relaxed">
            空室状況や詳しい料金など、すぐにご案内いたします。<br className="hidden sm:block" />
            ご質問だけでも大歓迎です!
          </p>
          <div className="hidden md:block">
            <Link
              to="/reservation"
              className="inline-block bg-gradient-to-r from-teal-500 to-cyan-600 text-white px-8 sm:px-12 py-3 sm:py-4 rounded-full text-base sm:text-lg font-bold hover:from-teal-600 hover:to-cyan-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              ご予約はこちらから
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-gray-300 py-8 md:py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-6 md:mb-8">
            <h3 className="text-xl sm:text-2xl md:text-4xl font-bold text-white mb-2">Guesthouse017大阪</h3>
            <p className="text-sm sm:text-base text-gray-400">家族・団体旅行に最適な一棟貸切施設</p>
          </div>
          <div className="text-center text-xs sm:text-sm text-gray-500 border-t border-gray-700 pt-6 md:pt-8">
            <p className="mb-2">&copy; 2024 Guesthouse017大阪. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>

      {/* Google Apps Script カウンター更新スクリプト - PC版のみ */}
      <script dangerouslySetInnerHTML={{
        __html: `
          (function () {
            const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbz84FhRv3RBE0qCZqT4gIXeAomlZoiNiychS5gS4QN46TVWuIP65TRKyj6bTlUSBPlA3A/exec';

            async function updateCounters() {
              try {
                const res = await fetch(SCRIPT_URL);
                if (!res.ok) throw new Error('API error: ' + res.status);
                const data = await res.json();

                const current = document.getElementById('counter-current');
                const today = document.getElementById('counter-today');
                const total = document.getElementById('counter-total');

                if (current && data.activeUsers != null) {
                  current.textContent = data.activeUsers.toLocaleString();
                }
                if (today && data.todayViews != null) {
                  today.textContent = data.todayViews.toLocaleString();
                }
                if (total && data.totalViews != null) {
                  total.textContent = data.totalViews.toLocaleString();
                }
              } catch (e) {
                console.error('Counter update error', e);
              }
            }

            document.addEventListener('DOMContentLoaded', updateCounters);
          })();
        `
      }} />

      {/* Fixed Contact Buttons */}
      <div className="fixed left-0 right-0 bg-white/95 backdrop-blur-sm shadow-[0_-4px_20px_rgba(0,0,0,0.08)] z-50 md:hidden pb-safe" style={{ bottom: '12px' }}>
        <div className="px-4 pt-3 pb-3">
          <Link
            to="/reservation"
            className="block w-1/2 bg-gradient-to-r from-teal-500 to-cyan-600 hover:from-teal-600 hover:to-cyan-700 text-white py-3 rounded-full font-medium shadow-lg transition-all active:scale-[0.98] whitespace-nowrap text-center"
          >
            今すぐ予約
          </Link>
        </div>
      </div>
    </div>
  );
}
